const LEGAL_URLS = {
  privacy: "https://skyboard.es/privacy",
  terms: "https://skyboard.es/terms",
  cookies: "https://skyboard.es/cookies",
};

export { LEGAL_URLS };

export function LegalLinks({ className = "" }) {
  const linkClass = "text-slate-300 hover:text-sky-400 underline underline-offset-4 transition-colors";
  return (
    <nav
      className={`mt-6 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs text-slate-400 ${className}`}
      aria-label="Información legal"
      data-testid="legal-links"
    >
      <a
        href={LEGAL_URLS.privacy}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClass}
        data-testid="legal-privacy-link"
      >
        Política de Privacidad
      </a>
      <span aria-hidden="true" className="text-slate-600">·</span>
      <a
        href={LEGAL_URLS.terms}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClass}
        data-testid="legal-terms-link"
      >
        Términos de Servicio
      </a>
      <span aria-hidden="true" className="text-slate-600">·</span>
      <a
        href={LEGAL_URLS.cookies}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClass}
        data-testid="legal-cookies-link"
      >
        Política de Cookies
      </a>
    </nav>
  );
}
